var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3088({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "#747BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5255 9C16.3454 9 14.5781 10.7673 14.5781 12.9474V18.2105C14.5781 20.3907 16.3454 22.1579 18.5255 22.1579C20.7056 22.1579 22.4729 20.3907 22.4729 18.2105V12.9474C22.4729 10.7673 20.7056 9 18.5255 9ZM20.4992 18.2105C20.4992 19.3005 19.6155 20.1842 18.5255 20.1842C17.4355 20.1842 16.5518 19.3005 16.5518 18.2105V12.9474C16.5518 11.8573 17.4355 10.9737 18.5255 10.9737C19.6155 10.9737 20.4992 11.8573 20.4992 12.9474V18.2105Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9474 20.1841C11.9474 21.2741 11.0637 22.1578 9.97368 22.1578C8.88364 22.1578 8 21.2741 8 20.1841C8 19.0941 8.88364 18.2104 9.97368 18.2104C11.0637 18.2104 11.9474 19.0941 11.9474 20.1841Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0265 12.9474V18.2105C31.0265 18.3474 31.0126 18.4811 30.986 18.6101C31.6293 18.8143 32.2394 19.0925 32.8067 19.4347C32.9323 19.0493 33.0002 18.6379 33.0002 18.2105V12.9474C33.0002 10.7673 31.233 9 29.0528 9C26.8727 9 25.1055 10.7673 25.1055 12.9474V18.2105C25.1055 18.4266 25.1228 18.6384 25.1563 18.845C25.766 18.5954 26.411 18.4141 27.0817 18.3108C27.0799 18.2775 27.0792 18.2441 27.0792 18.2105V12.9474C27.0792 11.8573 27.9628 10.9737 29.0528 10.9737C30.1428 10.9737 31.0265 11.8573 31.0265 12.9474Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6319 26.7632C35.6319 30.7601 32.3919 34.0001 28.395 34.0001C24.3982 34.0001 21.1582 30.7601 21.1582 26.7632C21.1582 22.7664 24.3982 19.5264 28.395 19.5264C32.3919 19.5264 35.6319 22.7664 35.6319 26.7632ZM32.3424 27.4211C32.7057 27.4211 33.0003 27.1265 33.0003 26.7632C33.0003 26.3999 32.7057 26.1053 32.3424 26.1053H26.036L28.2024 23.939C28.4593 23.682 28.4593 23.2654 28.2024 23.0085C27.9454 22.7516 27.5289 22.7516 27.2719 23.0085L23.9824 26.2979C23.7256 26.5549 23.7256 26.9715 23.9824 27.2285L27.2719 30.5179C27.5289 30.7748 27.9454 30.7748 28.2024 30.5179C28.4593 30.261 28.4593 29.8444 28.2024 29.5874L26.036 27.4211H32.3424Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3088);
export default __webpack_public_path__ + "static/media/Group 3088.527a6e99f035b373a722c770925307d1.svg";
export { ForwardRef as ReactComponent };